/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LinkImport } from './routes/link'
import { Route as DashboardImport } from './routes/_dashboard'
import { Route as IndexImport } from './routes/index'
import { Route as LinkTransfersImport } from './routes/link/transfers'
import { Route as LinkTransactionsImport } from './routes/link/transactions'
import { Route as LinkDemoImport } from './routes/link/demo'
import { Route as LinkConnectAccountImport } from './routes/link/connect-account'
import { Route as LinkActivePositionsImport } from './routes/link/active-positions'
import { Route as DashboardAuthenticatedImport } from './routes/_dashboard/_authenticated'
import { Route as DashboardAuthImport } from './routes/_dashboard/_auth'
import { Route as LinkDemoTransactionsImport } from './routes/link/demo_/transactions'
import { Route as LinkDemoPositionsImport } from './routes/link/demo_/positions'
import { Route as DashboardAuthenticatedProfileImport } from './routes/_dashboard/_authenticated/profile'
import { Route as DashboardAuthenticatedOverviewImport } from './routes/_dashboard/_authenticated/overview'
import { Route as DashboardAuthenticatedOrganizationImport } from './routes/_dashboard/_authenticated/organization'
import { Route as DashboardAuthenticatedAdminImport } from './routes/_dashboard/_authenticated/admin'
import { Route as DashboardAuthResetPasswordImport } from './routes/_dashboard/_auth/reset-password'
import { Route as DashboardAuthRecoverPasswordImport } from './routes/_dashboard/_auth/recover-password'
import { Route as DashboardAuthLoginImport } from './routes/_dashboard/_auth/login'
import { Route as DashboardAuthenticatedAppTransfersImport } from './routes/_dashboard/_authenticated/app/transfers'
import { Route as DashboardAuthenticatedAppTransactionsImport } from './routes/_dashboard/_authenticated/app/transactions'
import { Route as DashboardAuthenticatedAppSettingsImport } from './routes/_dashboard/_authenticated/app/settings'
import { Route as DashboardAuthenticatedAppPositionsImport } from './routes/_dashboard/_authenticated/app/positions'
import { Route as DashboardAuthenticatedAppOverviewImport } from './routes/_dashboard/_authenticated/app/overview'

// Create/Update Routes

const LinkRoute = LinkImport.update({
  id: '/link',
  path: '/link',
  getParentRoute: () => rootRoute,
} as any)

const DashboardRoute = DashboardImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const LinkTransfersRoute = LinkTransfersImport.update({
  id: '/transfers',
  path: '/transfers',
  getParentRoute: () => LinkRoute,
} as any)

const LinkTransactionsRoute = LinkTransactionsImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => LinkRoute,
} as any)

const LinkDemoRoute = LinkDemoImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => LinkRoute,
} as any)

const LinkConnectAccountRoute = LinkConnectAccountImport.update({
  id: '/connect-account',
  path: '/connect-account',
  getParentRoute: () => LinkRoute,
} as any)

const LinkActivePositionsRoute = LinkActivePositionsImport.update({
  id: '/active-positions',
  path: '/active-positions',
  getParentRoute: () => LinkRoute,
} as any)

const DashboardAuthenticatedRoute = DashboardAuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => DashboardRoute,
} as any)

const DashboardAuthRoute = DashboardAuthImport.update({
  id: '/_auth',
  getParentRoute: () => DashboardRoute,
} as any)

const LinkDemoTransactionsRoute = LinkDemoTransactionsImport.update({
  id: '/demo_/transactions',
  path: '/demo/transactions',
  getParentRoute: () => LinkRoute,
} as any)

const LinkDemoPositionsRoute = LinkDemoPositionsImport.update({
  id: '/demo_/positions',
  path: '/demo/positions',
  getParentRoute: () => LinkRoute,
} as any)

const DashboardAuthenticatedProfileRoute =
  DashboardAuthenticatedProfileImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => DashboardAuthenticatedRoute,
  } as any)

const DashboardAuthenticatedOverviewRoute =
  DashboardAuthenticatedOverviewImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => DashboardAuthenticatedRoute,
  } as any)

const DashboardAuthenticatedOrganizationRoute =
  DashboardAuthenticatedOrganizationImport.update({
    id: '/organization',
    path: '/organization',
    getParentRoute: () => DashboardAuthenticatedRoute,
  } as any)

const DashboardAuthenticatedAdminRoute =
  DashboardAuthenticatedAdminImport.update({
    id: '/admin',
    path: '/admin',
    getParentRoute: () => DashboardAuthenticatedRoute,
  } as any)

const DashboardAuthResetPasswordRoute = DashboardAuthResetPasswordImport.update(
  {
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => DashboardAuthRoute,
  } as any,
)

const DashboardAuthRecoverPasswordRoute =
  DashboardAuthRecoverPasswordImport.update({
    id: '/recover-password',
    path: '/recover-password',
    getParentRoute: () => DashboardAuthRoute,
  } as any)

const DashboardAuthLoginRoute = DashboardAuthLoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => DashboardAuthRoute,
} as any)

const DashboardAuthenticatedAppTransfersRoute =
  DashboardAuthenticatedAppTransfersImport.update({
    id: '/app/transfers',
    path: '/app/transfers',
    getParentRoute: () => DashboardAuthenticatedRoute,
  } as any)

const DashboardAuthenticatedAppTransactionsRoute =
  DashboardAuthenticatedAppTransactionsImport.update({
    id: '/app/transactions',
    path: '/app/transactions',
    getParentRoute: () => DashboardAuthenticatedRoute,
  } as any)

const DashboardAuthenticatedAppSettingsRoute =
  DashboardAuthenticatedAppSettingsImport.update({
    id: '/app/settings',
    path: '/app/settings',
    getParentRoute: () => DashboardAuthenticatedRoute,
  } as any)

const DashboardAuthenticatedAppPositionsRoute =
  DashboardAuthenticatedAppPositionsImport.update({
    id: '/app/positions',
    path: '/app/positions',
    getParentRoute: () => DashboardAuthenticatedRoute,
  } as any)

const DashboardAuthenticatedAppOverviewRoute =
  DashboardAuthenticatedAppOverviewImport.update({
    id: '/app/overview',
    path: '/app/overview',
    getParentRoute: () => DashboardAuthenticatedRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardImport
      parentRoute: typeof rootRoute
    }
    '/link': {
      id: '/link'
      path: '/link'
      fullPath: '/link'
      preLoaderRoute: typeof LinkImport
      parentRoute: typeof rootRoute
    }
    '/_dashboard/_auth': {
      id: '/_dashboard/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardAuthImport
      parentRoute: typeof DashboardImport
    }
    '/_dashboard/_authenticated': {
      id: '/_dashboard/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof DashboardAuthenticatedImport
      parentRoute: typeof DashboardImport
    }
    '/link/active-positions': {
      id: '/link/active-positions'
      path: '/active-positions'
      fullPath: '/link/active-positions'
      preLoaderRoute: typeof LinkActivePositionsImport
      parentRoute: typeof LinkImport
    }
    '/link/connect-account': {
      id: '/link/connect-account'
      path: '/connect-account'
      fullPath: '/link/connect-account'
      preLoaderRoute: typeof LinkConnectAccountImport
      parentRoute: typeof LinkImport
    }
    '/link/demo': {
      id: '/link/demo'
      path: '/demo'
      fullPath: '/link/demo'
      preLoaderRoute: typeof LinkDemoImport
      parentRoute: typeof LinkImport
    }
    '/link/transactions': {
      id: '/link/transactions'
      path: '/transactions'
      fullPath: '/link/transactions'
      preLoaderRoute: typeof LinkTransactionsImport
      parentRoute: typeof LinkImport
    }
    '/link/transfers': {
      id: '/link/transfers'
      path: '/transfers'
      fullPath: '/link/transfers'
      preLoaderRoute: typeof LinkTransfersImport
      parentRoute: typeof LinkImport
    }
    '/_dashboard/_auth/login': {
      id: '/_dashboard/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof DashboardAuthLoginImport
      parentRoute: typeof DashboardAuthImport
    }
    '/_dashboard/_auth/recover-password': {
      id: '/_dashboard/_auth/recover-password'
      path: '/recover-password'
      fullPath: '/recover-password'
      preLoaderRoute: typeof DashboardAuthRecoverPasswordImport
      parentRoute: typeof DashboardAuthImport
    }
    '/_dashboard/_auth/reset-password': {
      id: '/_dashboard/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof DashboardAuthResetPasswordImport
      parentRoute: typeof DashboardAuthImport
    }
    '/_dashboard/_authenticated/admin': {
      id: '/_dashboard/_authenticated/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof DashboardAuthenticatedAdminImport
      parentRoute: typeof DashboardAuthenticatedImport
    }
    '/_dashboard/_authenticated/organization': {
      id: '/_dashboard/_authenticated/organization'
      path: '/organization'
      fullPath: '/organization'
      preLoaderRoute: typeof DashboardAuthenticatedOrganizationImport
      parentRoute: typeof DashboardAuthenticatedImport
    }
    '/_dashboard/_authenticated/overview': {
      id: '/_dashboard/_authenticated/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof DashboardAuthenticatedOverviewImport
      parentRoute: typeof DashboardAuthenticatedImport
    }
    '/_dashboard/_authenticated/profile': {
      id: '/_dashboard/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof DashboardAuthenticatedProfileImport
      parentRoute: typeof DashboardAuthenticatedImport
    }
    '/link/demo_/positions': {
      id: '/link/demo_/positions'
      path: '/demo/positions'
      fullPath: '/link/demo/positions'
      preLoaderRoute: typeof LinkDemoPositionsImport
      parentRoute: typeof LinkImport
    }
    '/link/demo_/transactions': {
      id: '/link/demo_/transactions'
      path: '/demo/transactions'
      fullPath: '/link/demo/transactions'
      preLoaderRoute: typeof LinkDemoTransactionsImport
      parentRoute: typeof LinkImport
    }
    '/_dashboard/_authenticated/app/overview': {
      id: '/_dashboard/_authenticated/app/overview'
      path: '/app/overview'
      fullPath: '/app/overview'
      preLoaderRoute: typeof DashboardAuthenticatedAppOverviewImport
      parentRoute: typeof DashboardAuthenticatedImport
    }
    '/_dashboard/_authenticated/app/positions': {
      id: '/_dashboard/_authenticated/app/positions'
      path: '/app/positions'
      fullPath: '/app/positions'
      preLoaderRoute: typeof DashboardAuthenticatedAppPositionsImport
      parentRoute: typeof DashboardAuthenticatedImport
    }
    '/_dashboard/_authenticated/app/settings': {
      id: '/_dashboard/_authenticated/app/settings'
      path: '/app/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof DashboardAuthenticatedAppSettingsImport
      parentRoute: typeof DashboardAuthenticatedImport
    }
    '/_dashboard/_authenticated/app/transactions': {
      id: '/_dashboard/_authenticated/app/transactions'
      path: '/app/transactions'
      fullPath: '/app/transactions'
      preLoaderRoute: typeof DashboardAuthenticatedAppTransactionsImport
      parentRoute: typeof DashboardAuthenticatedImport
    }
    '/_dashboard/_authenticated/app/transfers': {
      id: '/_dashboard/_authenticated/app/transfers'
      path: '/app/transfers'
      fullPath: '/app/transfers'
      preLoaderRoute: typeof DashboardAuthenticatedAppTransfersImport
      parentRoute: typeof DashboardAuthenticatedImport
    }
  }
}

// Create and export the route tree

interface DashboardAuthRouteChildren {
  DashboardAuthLoginRoute: typeof DashboardAuthLoginRoute
  DashboardAuthRecoverPasswordRoute: typeof DashboardAuthRecoverPasswordRoute
  DashboardAuthResetPasswordRoute: typeof DashboardAuthResetPasswordRoute
}

const DashboardAuthRouteChildren: DashboardAuthRouteChildren = {
  DashboardAuthLoginRoute: DashboardAuthLoginRoute,
  DashboardAuthRecoverPasswordRoute: DashboardAuthRecoverPasswordRoute,
  DashboardAuthResetPasswordRoute: DashboardAuthResetPasswordRoute,
}

const DashboardAuthRouteWithChildren = DashboardAuthRoute._addFileChildren(
  DashboardAuthRouteChildren,
)

interface DashboardAuthenticatedRouteChildren {
  DashboardAuthenticatedAdminRoute: typeof DashboardAuthenticatedAdminRoute
  DashboardAuthenticatedOrganizationRoute: typeof DashboardAuthenticatedOrganizationRoute
  DashboardAuthenticatedOverviewRoute: typeof DashboardAuthenticatedOverviewRoute
  DashboardAuthenticatedProfileRoute: typeof DashboardAuthenticatedProfileRoute
  DashboardAuthenticatedAppOverviewRoute: typeof DashboardAuthenticatedAppOverviewRoute
  DashboardAuthenticatedAppPositionsRoute: typeof DashboardAuthenticatedAppPositionsRoute
  DashboardAuthenticatedAppSettingsRoute: typeof DashboardAuthenticatedAppSettingsRoute
  DashboardAuthenticatedAppTransactionsRoute: typeof DashboardAuthenticatedAppTransactionsRoute
  DashboardAuthenticatedAppTransfersRoute: typeof DashboardAuthenticatedAppTransfersRoute
}

const DashboardAuthenticatedRouteChildren: DashboardAuthenticatedRouteChildren =
  {
    DashboardAuthenticatedAdminRoute: DashboardAuthenticatedAdminRoute,
    DashboardAuthenticatedOrganizationRoute:
      DashboardAuthenticatedOrganizationRoute,
    DashboardAuthenticatedOverviewRoute: DashboardAuthenticatedOverviewRoute,
    DashboardAuthenticatedProfileRoute: DashboardAuthenticatedProfileRoute,
    DashboardAuthenticatedAppOverviewRoute:
      DashboardAuthenticatedAppOverviewRoute,
    DashboardAuthenticatedAppPositionsRoute:
      DashboardAuthenticatedAppPositionsRoute,
    DashboardAuthenticatedAppSettingsRoute:
      DashboardAuthenticatedAppSettingsRoute,
    DashboardAuthenticatedAppTransactionsRoute:
      DashboardAuthenticatedAppTransactionsRoute,
    DashboardAuthenticatedAppTransfersRoute:
      DashboardAuthenticatedAppTransfersRoute,
  }

const DashboardAuthenticatedRouteWithChildren =
  DashboardAuthenticatedRoute._addFileChildren(
    DashboardAuthenticatedRouteChildren,
  )

interface DashboardRouteChildren {
  DashboardAuthRoute: typeof DashboardAuthRouteWithChildren
  DashboardAuthenticatedRoute: typeof DashboardAuthenticatedRouteWithChildren
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardAuthRoute: DashboardAuthRouteWithChildren,
  DashboardAuthenticatedRoute: DashboardAuthenticatedRouteWithChildren,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

interface LinkRouteChildren {
  LinkActivePositionsRoute: typeof LinkActivePositionsRoute
  LinkConnectAccountRoute: typeof LinkConnectAccountRoute
  LinkDemoRoute: typeof LinkDemoRoute
  LinkTransactionsRoute: typeof LinkTransactionsRoute
  LinkTransfersRoute: typeof LinkTransfersRoute
  LinkDemoPositionsRoute: typeof LinkDemoPositionsRoute
  LinkDemoTransactionsRoute: typeof LinkDemoTransactionsRoute
}

const LinkRouteChildren: LinkRouteChildren = {
  LinkActivePositionsRoute: LinkActivePositionsRoute,
  LinkConnectAccountRoute: LinkConnectAccountRoute,
  LinkDemoRoute: LinkDemoRoute,
  LinkTransactionsRoute: LinkTransactionsRoute,
  LinkTransfersRoute: LinkTransfersRoute,
  LinkDemoPositionsRoute: LinkDemoPositionsRoute,
  LinkDemoTransactionsRoute: LinkDemoTransactionsRoute,
}

const LinkRouteWithChildren = LinkRoute._addFileChildren(LinkRouteChildren)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof DashboardAuthenticatedRouteWithChildren
  '/link': typeof LinkRouteWithChildren
  '/link/active-positions': typeof LinkActivePositionsRoute
  '/link/connect-account': typeof LinkConnectAccountRoute
  '/link/demo': typeof LinkDemoRoute
  '/link/transactions': typeof LinkTransactionsRoute
  '/link/transfers': typeof LinkTransfersRoute
  '/login': typeof DashboardAuthLoginRoute
  '/recover-password': typeof DashboardAuthRecoverPasswordRoute
  '/reset-password': typeof DashboardAuthResetPasswordRoute
  '/admin': typeof DashboardAuthenticatedAdminRoute
  '/organization': typeof DashboardAuthenticatedOrganizationRoute
  '/overview': typeof DashboardAuthenticatedOverviewRoute
  '/profile': typeof DashboardAuthenticatedProfileRoute
  '/link/demo/positions': typeof LinkDemoPositionsRoute
  '/link/demo/transactions': typeof LinkDemoTransactionsRoute
  '/app/overview': typeof DashboardAuthenticatedAppOverviewRoute
  '/app/positions': typeof DashboardAuthenticatedAppPositionsRoute
  '/app/settings': typeof DashboardAuthenticatedAppSettingsRoute
  '/app/transactions': typeof DashboardAuthenticatedAppTransactionsRoute
  '/app/transfers': typeof DashboardAuthenticatedAppTransfersRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof DashboardAuthenticatedRouteWithChildren
  '/link': typeof LinkRouteWithChildren
  '/link/active-positions': typeof LinkActivePositionsRoute
  '/link/connect-account': typeof LinkConnectAccountRoute
  '/link/demo': typeof LinkDemoRoute
  '/link/transactions': typeof LinkTransactionsRoute
  '/link/transfers': typeof LinkTransfersRoute
  '/login': typeof DashboardAuthLoginRoute
  '/recover-password': typeof DashboardAuthRecoverPasswordRoute
  '/reset-password': typeof DashboardAuthResetPasswordRoute
  '/admin': typeof DashboardAuthenticatedAdminRoute
  '/organization': typeof DashboardAuthenticatedOrganizationRoute
  '/overview': typeof DashboardAuthenticatedOverviewRoute
  '/profile': typeof DashboardAuthenticatedProfileRoute
  '/link/demo/positions': typeof LinkDemoPositionsRoute
  '/link/demo/transactions': typeof LinkDemoTransactionsRoute
  '/app/overview': typeof DashboardAuthenticatedAppOverviewRoute
  '/app/positions': typeof DashboardAuthenticatedAppPositionsRoute
  '/app/settings': typeof DashboardAuthenticatedAppSettingsRoute
  '/app/transactions': typeof DashboardAuthenticatedAppTransactionsRoute
  '/app/transfers': typeof DashboardAuthenticatedAppTransfersRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_dashboard': typeof DashboardRouteWithChildren
  '/link': typeof LinkRouteWithChildren
  '/_dashboard/_auth': typeof DashboardAuthRouteWithChildren
  '/_dashboard/_authenticated': typeof DashboardAuthenticatedRouteWithChildren
  '/link/active-positions': typeof LinkActivePositionsRoute
  '/link/connect-account': typeof LinkConnectAccountRoute
  '/link/demo': typeof LinkDemoRoute
  '/link/transactions': typeof LinkTransactionsRoute
  '/link/transfers': typeof LinkTransfersRoute
  '/_dashboard/_auth/login': typeof DashboardAuthLoginRoute
  '/_dashboard/_auth/recover-password': typeof DashboardAuthRecoverPasswordRoute
  '/_dashboard/_auth/reset-password': typeof DashboardAuthResetPasswordRoute
  '/_dashboard/_authenticated/admin': typeof DashboardAuthenticatedAdminRoute
  '/_dashboard/_authenticated/organization': typeof DashboardAuthenticatedOrganizationRoute
  '/_dashboard/_authenticated/overview': typeof DashboardAuthenticatedOverviewRoute
  '/_dashboard/_authenticated/profile': typeof DashboardAuthenticatedProfileRoute
  '/link/demo_/positions': typeof LinkDemoPositionsRoute
  '/link/demo_/transactions': typeof LinkDemoTransactionsRoute
  '/_dashboard/_authenticated/app/overview': typeof DashboardAuthenticatedAppOverviewRoute
  '/_dashboard/_authenticated/app/positions': typeof DashboardAuthenticatedAppPositionsRoute
  '/_dashboard/_authenticated/app/settings': typeof DashboardAuthenticatedAppSettingsRoute
  '/_dashboard/_authenticated/app/transactions': typeof DashboardAuthenticatedAppTransactionsRoute
  '/_dashboard/_authenticated/app/transfers': typeof DashboardAuthenticatedAppTransfersRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/link'
    | '/link/active-positions'
    | '/link/connect-account'
    | '/link/demo'
    | '/link/transactions'
    | '/link/transfers'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/admin'
    | '/organization'
    | '/overview'
    | '/profile'
    | '/link/demo/positions'
    | '/link/demo/transactions'
    | '/app/overview'
    | '/app/positions'
    | '/app/settings'
    | '/app/transactions'
    | '/app/transfers'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/link'
    | '/link/active-positions'
    | '/link/connect-account'
    | '/link/demo'
    | '/link/transactions'
    | '/link/transfers'
    | '/login'
    | '/recover-password'
    | '/reset-password'
    | '/admin'
    | '/organization'
    | '/overview'
    | '/profile'
    | '/link/demo/positions'
    | '/link/demo/transactions'
    | '/app/overview'
    | '/app/positions'
    | '/app/settings'
    | '/app/transactions'
    | '/app/transfers'
  id:
    | '__root__'
    | '/'
    | '/_dashboard'
    | '/link'
    | '/_dashboard/_auth'
    | '/_dashboard/_authenticated'
    | '/link/active-positions'
    | '/link/connect-account'
    | '/link/demo'
    | '/link/transactions'
    | '/link/transfers'
    | '/_dashboard/_auth/login'
    | '/_dashboard/_auth/recover-password'
    | '/_dashboard/_auth/reset-password'
    | '/_dashboard/_authenticated/admin'
    | '/_dashboard/_authenticated/organization'
    | '/_dashboard/_authenticated/overview'
    | '/_dashboard/_authenticated/profile'
    | '/link/demo_/positions'
    | '/link/demo_/transactions'
    | '/_dashboard/_authenticated/app/overview'
    | '/_dashboard/_authenticated/app/positions'
    | '/_dashboard/_authenticated/app/settings'
    | '/_dashboard/_authenticated/app/transactions'
    | '/_dashboard/_authenticated/app/transfers'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  LinkRoute: typeof LinkRouteWithChildren
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  LinkRoute: LinkRouteWithChildren,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_dashboard",
        "/link"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_dashboard": {
      "filePath": "_dashboard.tsx",
      "children": [
        "/_dashboard/_auth",
        "/_dashboard/_authenticated"
      ]
    },
    "/link": {
      "filePath": "link.tsx",
      "children": [
        "/link/active-positions",
        "/link/connect-account",
        "/link/demo",
        "/link/transactions",
        "/link/transfers",
        "/link/demo_/positions",
        "/link/demo_/transactions"
      ]
    },
    "/_dashboard/_auth": {
      "filePath": "_dashboard/_auth.tsx",
      "parent": "/_dashboard",
      "children": [
        "/_dashboard/_auth/login",
        "/_dashboard/_auth/recover-password",
        "/_dashboard/_auth/reset-password"
      ]
    },
    "/_dashboard/_authenticated": {
      "filePath": "_dashboard/_authenticated.tsx",
      "parent": "/_dashboard",
      "children": [
        "/_dashboard/_authenticated/admin",
        "/_dashboard/_authenticated/organization",
        "/_dashboard/_authenticated/overview",
        "/_dashboard/_authenticated/profile",
        "/_dashboard/_authenticated/app/overview",
        "/_dashboard/_authenticated/app/positions",
        "/_dashboard/_authenticated/app/settings",
        "/_dashboard/_authenticated/app/transactions",
        "/_dashboard/_authenticated/app/transfers"
      ]
    },
    "/link/active-positions": {
      "filePath": "link/active-positions.tsx",
      "parent": "/link"
    },
    "/link/connect-account": {
      "filePath": "link/connect-account.tsx",
      "parent": "/link"
    },
    "/link/demo": {
      "filePath": "link/demo.tsx",
      "parent": "/link"
    },
    "/link/transactions": {
      "filePath": "link/transactions.tsx",
      "parent": "/link"
    },
    "/link/transfers": {
      "filePath": "link/transfers.tsx",
      "parent": "/link"
    },
    "/_dashboard/_auth/login": {
      "filePath": "_dashboard/_auth/login.tsx",
      "parent": "/_dashboard/_auth"
    },
    "/_dashboard/_auth/recover-password": {
      "filePath": "_dashboard/_auth/recover-password.tsx",
      "parent": "/_dashboard/_auth"
    },
    "/_dashboard/_auth/reset-password": {
      "filePath": "_dashboard/_auth/reset-password.tsx",
      "parent": "/_dashboard/_auth"
    },
    "/_dashboard/_authenticated/admin": {
      "filePath": "_dashboard/_authenticated/admin.tsx",
      "parent": "/_dashboard/_authenticated"
    },
    "/_dashboard/_authenticated/organization": {
      "filePath": "_dashboard/_authenticated/organization.tsx",
      "parent": "/_dashboard/_authenticated"
    },
    "/_dashboard/_authenticated/overview": {
      "filePath": "_dashboard/_authenticated/overview.tsx",
      "parent": "/_dashboard/_authenticated"
    },
    "/_dashboard/_authenticated/profile": {
      "filePath": "_dashboard/_authenticated/profile.tsx",
      "parent": "/_dashboard/_authenticated"
    },
    "/link/demo_/positions": {
      "filePath": "link/demo_/positions.tsx",
      "parent": "/link"
    },
    "/link/demo_/transactions": {
      "filePath": "link/demo_/transactions.tsx",
      "parent": "/link"
    },
    "/_dashboard/_authenticated/app/overview": {
      "filePath": "_dashboard/_authenticated/app/overview.tsx",
      "parent": "/_dashboard/_authenticated"
    },
    "/_dashboard/_authenticated/app/positions": {
      "filePath": "_dashboard/_authenticated/app/positions.tsx",
      "parent": "/_dashboard/_authenticated"
    },
    "/_dashboard/_authenticated/app/settings": {
      "filePath": "_dashboard/_authenticated/app/settings.tsx",
      "parent": "/_dashboard/_authenticated"
    },
    "/_dashboard/_authenticated/app/transactions": {
      "filePath": "_dashboard/_authenticated/app/transactions.tsx",
      "parent": "/_dashboard/_authenticated"
    },
    "/_dashboard/_authenticated/app/transfers": {
      "filePath": "_dashboard/_authenticated/app/transfers.tsx",
      "parent": "/_dashboard/_authenticated"
    }
  }
}
ROUTE_MANIFEST_END */
